import { api } from '../client';

export interface PartnerNetwork {
  id: string;
  ownerCompanyId: string;
  ownerCompany?: {
    id: string;
    name: string;
    displayName: string;
    type?: string;
  };
  partnerCompanyId: string;
  partnerCompany?: {
    id: string;
    name: string;
    displayName: string;
    type?: string;
  };
  partnerTypes: string[];
  status: 'PENDING' | 'ACTIVE' | 'SUSPENDED' | 'TERMINATED';
  accessLevel: 'READ_ONLY' | 'READ_WRITE' | 'FULL';
  visibility: 'FULL' | 'LIMITED' | 'RESTRICTED';
  contractReference?: string;
  relationshipStartDate?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePartnerNetworkDto {
  partnerCompanyId: string;
  partnerTypes: string[];
  status?: 'PENDING' | 'ACTIVE' | 'SUSPENDED' | 'TERMINATED';
  accessLevel?: 'READ_ONLY' | 'READ_WRITE' | 'FULL';
  visibility?: 'FULL' | 'LIMITED' | 'RESTRICTED';
  contractReference?: string;
  relationshipStartDate?: string;
}

export const partnerNetworksApi = {
  async getAll() {
    const response = await api.get<{
      asOwner: PartnerNetwork[];
      asPartner: PartnerNetwork[];
    }>('/api/partner-networks');
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get<PartnerNetwork>(`/api/partner-networks/${id}`);
    return response.data;
  },

  async create(data: CreatePartnerNetworkDto) {
    const response = await api.post<PartnerNetwork>('/api/partner-networks', data);
    return response.data;
  },

  async update(id: string, data: Partial<CreatePartnerNetworkDto>) {
    const response = await api.patch<PartnerNetwork>(
      `/api/partner-networks/${id}`,
      data
    );
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete(`/api/partner-networks/${id}`);
    return response.data;
  },

  async accept(id: string) {
    const response = await api.post<PartnerNetwork>(
      `/api/partner-networks/${id}/accept`
    );
    return response.data;
  },
};
